/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropvalidationplacerequired3Inputs */

const en_dropvalidationplacerequired3 = /** @type {(inputs: Dropvalidationplacerequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick the place where the voucher is redeemed.`)
};

const de_dropvalidationplacerequired3 = /** @type {(inputs: Dropvalidationplacerequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle den Ort, an dem der Gutschein eingelöst wird.`)
};

/**
* | output |
* | --- |
* | "Pick the place where the voucher is redeemed." |
*
* @param {Dropvalidationplacerequired3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropvalidationplacerequired3 = /** @type {((inputs?: Dropvalidationplacerequired3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropvalidationplacerequired3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropvalidationplacerequired3(inputs)
	return de_dropvalidationplacerequired3(inputs)
});
export { dropvalidationplacerequired3 as "dropValidationPlaceRequired" }